export default {
  title: 'Ny kategori',
  form: {
    menus: {
      label: 'Menuer',
    },
    printer: {
      label: 'Printer',
    },
    type: {
      label: 'Type',
    },
    name: {
      label: 'Navn',
      placeholder: 'Indtast kategorinavn',
    },
    description: {
      label: 'Beskrivelse',
      placeholder: 'Indtast beskrivelse',
    },
    has_combo_tax: {
      label: 'Har kombinationsmoms',
    },
    modifier_groups: {
      label: 'Tilvalgsgrupper',
    },
    image: {
      label: 'Billede',
    },
    identifiers: {
      label: 'Identifikatorer',
    },
    has_separate_schedule: {
      label: 'Afviger fra menuplan',
    },
  },
  buttons: {
    save: 'Gem',
    close: 'Luk',
  },
  feedback: {
    missing_info: 'Manglende oplysninger',
  },
  toasts: {
    category_got_created: 'Kategorien er oprettet',
    category_got_updated: 'Kategorien er opdateret',
  },
};
